import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';

import type {
  Action,
  Dispatch,
  InfluencerCreatorNetworkState,
  NetworkGraphDataRaw,
  ThunkAction
} from 'types';

const { INFLUENCERS } = API.END_POINTS;

const CREATOR_NETWORK_LOADING = 'influencer/CREATOR_NETWORK_LOADING';
const CREATOR_NETWORK_LOADED = 'influencer/CREATOR_NETWORK_LOADED';
const CREATOR_NETWORK_RESET = 'influencer/CREATOR_NETWORK_RESET';

const initialState = {
  followers: {
    graphKey: '',
    nodes: [],
    links: []
  },
  isLoading: false
};

const setLoadingStatus = (status: boolean): Action => ({
  type: CREATOR_NETWORK_LOADING,

  payload: {
    status
  }
});

const notableFollowersLoaded = (followers: NetworkGraphDataRaw): Action => ({
  type: CREATOR_NETWORK_LOADED,

  payload: {
    followers
  }
});

export const resetNotableFollowers = (): Action => ({
  type: CREATOR_NETWORK_RESET
});

export const fetchNotableFollowers = (influencerProfileId: number): ThunkAction => async (dispatch: Dispatch) => { // eslint-disable-line consistent-return
  dispatch(setLoadingStatus(true));

  const queryString = '?directLimit=24&indirectLimit=6&graphConfigEnabled=true';

  try {
    const url = INFLUENCERS.getNotableFollowers(influencerProfileId, queryString);
    const response = await get(url, {}, { suppressGlobalNotification: true });
    const results = response.data || initialState;

    dispatch(setLoadingStatus(false));
    return dispatch(notableFollowersLoaded(results));
  } catch (error) {
    dispatch(setLoadingStatus(false));
    logError(error);
  }
};

const handleNotableFollowersLoading = (state: InfluencerCreatorNetworkState, { status }): InfluencerCreatorNetworkState => ({
  ...state,
  isLoading: status
});

const handleNotableFollowersLoaded = (state: InfluencerCreatorNetworkState, { followers }): InfluencerCreatorNetworkState => ({
  ...state,
  followers,
  isLoading: false
});

const handleNotableFollowersReset = (state: InfluencerCreatorNetworkState): InfluencerCreatorNetworkState => ({
  ...state,
  followers: initialState.followers,
  isLoading: false
});

export default createReducer<any, any>('influencerCreatorNetwork', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [CREATOR_NETWORK_LOADING]: handleNotableFollowersLoading,
  [CREATOR_NETWORK_LOADED]: handleNotableFollowersLoaded,
  [CREATOR_NETWORK_RESET]: handleNotableFollowersReset
});
